// tog‘a #2065 W1 (2026-09-15): formani skan nishoni sifatida ro‘yxatdan o‘tkazish.
// ⛔ Funksiyalar ref orqali o‘qiladi — obyekt/funksiya har renderda yangi bo‘lsa ham qayta ro‘yxatdan o‘tmaydi (websocket-identity-loop sabog‘i).
import { RefObject, useEffect, useRef } from "react"
import { registerScanTarget, ScanKind } from "./scanRegistry"
import type { ScanHit } from "./scanTypes"

export interface UseScanTargetOptions {
  kind: ScanKind
  /** false — ro‘yxatdan o‘tmaydi (masalan, savat ko‘rinmaydigan rejim) */
  enabled?: boolean
  needBatch?: boolean
  getWarehouseId?: () => number | undefined
  onScan: (hit: ScanHit) => void
}

export function useScanTarget(rootRef: RefObject<HTMLElement>, opts: UseScanTargetOptions) {
  const o = useRef(opts)
  o.current = opts
  const enabled = opts.enabled !== false
  useEffect(() => {
    if (!enabled) return
    return registerScanTarget({
      kind: o.current.kind,
      needBatch: o.current.needBatch,
      getEl: () => rootRef.current,
      getWarehouseId: () => o.current.getWarehouseId?.(),
      onScan: (hit) => o.current.onScan(hit),
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled])
}
